import { Outlet } from 'react-router-dom';
import { ReactComponent as CutDealerKerIcon } from 'assets/login/dealerker-half-icon.svg';
import { ReactComponent as CutDealerKerRightAlignIcon } from 'assets/login/dealerker-half-righ-align-icon.svg';
import LogoBlanco from 'assets/logo-dbd-posventa-blanco.png';
import { useLocation } from 'react-router-dom';
const PublicPage = () => {
  const location = useLocation();
  return (
    <div className="flex flex-col items-center overflow-y-auto overflow-x-hidden lg:justify-center h-screen w-screen relative bg-grey4">
      <div className="flex flex-wrap h-auto lg:h-full w-full">
        <div className="flex items-center justify-center w-full order-2 lg:order-1 lg:w-1/2 relative p-5">
          {location.pathname.includes('login') ? (
            <CutDealerKerIcon
              className={`absolute top-0 left-0`}
              height={150}
              width={250}
              color="#CEE6F0"
            />
          ) : (
            <CutDealerKerRightAlignIcon
              className={`absolute top-0 -right-20 z-0`}
              color="#CEE6F0"
              height={200}
              width={350}
            />
          )}
          <div className="flex items-center justify-center w-[427px] max-w-md z-10">
            <Outlet />
          </div>
        </div>
        <div
          className={`flex items-center justify-center relative h-[200px] order-1 lg:order-2 lg:h-auto w-full lg:w-1/2 bg-[url('assets/login/login-cover-image.svg')] bg-no-repeat bg-cover object-cover z-10`}
        >
          <div className="flex items-center justify-center h-full w-full bg-primary opacity-60" />
          <img
            src={LogoBlanco}
            alt=""
            className="absolute top-0 bottom-0 left-0 right-0 m-auto opacity-100 w-full h-auto max-w-[200px] md:max-w-[340px] xl:max-w-[520px]"
          />
        </div>
      </div>
    </div>
  );
};

export default PublicPage;
